import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReportsService } from '../../../core/services/reports.service';

@Component({
  selector: 'app-generate-report-modal',
  templateUrl: './generate-report-modal.component.html',
  styleUrls: ['./generate-report-modal.component.scss'],
})
export class GenerateReportModalComponent implements OnInit {
  @Output() handleGenerateReportModalOnChange: EventEmitter<any> =
    new EventEmitter();
  @Input() isVisibleGenerateReportModal = false;
  @Input() reportData: any;
  @Input() headerName = '';

  generateLoading = false;
  generatedReport: any;

  constructor(private reportService: ReportsService) {}

  ngOnInit() {
    this.generateReport();
  }

  async generateReport(): Promise<void> {
    this.generateLoading = true;
    try {
      this.generatedReport =
        await this.reportService.generateRentalAgreementReport(this.reportData);
      this.generateLoading = false;
    } catch (e) {}
  }

  Actions(type: string, report = this.generatedReport) {
    switch (type) {
      case 'preview':
        this.reportService.viewReport(report);
        break;
      case 'download':
        this.reportService.downloadReport(report);
        break;
      case 'email':
        this.reportService.emailPdf();
        break;
      case 'print':
        this.reportService.printReport(report);
        break;
    }
  }

  handleCancelGenerateReportModal() {
    this.handleGenerateReportModalOnChange.emit({
      action: 'Invisible',
    });
    this.isVisibleGenerateReportModal = false;
    this.reportData = null;
    this.generatedReport = null;
    this.headerName = '';
  }
}
